module.exports = __webpack_public_path__ + "static/media/Within Medical.27a22928.png";